export default {
  0: 'Include All Body ID',
  3: '3 DOORS',
  4: '4 DOORS',
  5: '5 DOORS'
}
